import get from 'lodash.get';

const getDialog = (rootState) => get(rootState, 'dialog');

export default getDialog;
